import { format } from 'date-fns'

import { t } from '@/i18n'
import type { StockItem } from '@/types'

import { EmptySeparator, InfoItem, Label, ProductsStockBreakdown } from './components'

function breakdown(items: StockItem[]) {
  const mappedItems = items
    .filter(item => item.stock !== undefined)
    .map(item => ({
      name: item.name,
      initial: item.refillValue ? item.refillValue : '-',
      toRestock: item.refillValue ? Math.max((item.refillValue || 0) - (item.stock ?? 0), 0) : '-',
      current: item.stock ?? 0
    }))
  return new ProductsStockBreakdown(mappedItems)
}

function generateStockReport(items: StockItem[]) {
  return [
    new Label(t('report.stock.title'), {
      style: 'bold 24px',
      lineHeight: 30
    }),
    new InfoItem(t('report.date'), format(new Date(), 'dd/MM/yyyy HH:mm'), {
      style: '16px'
    }),
    new EmptySeparator(),
    breakdown(items)
  ]
}

export default generateStockReport
